<div class="wm-view">
  <div class="wm-topbar">
    <div class="wm-topbar-header">Change Email Address</div>
  </div>
  <div class="wm-card">
    <div class="wm-card-content">
      @switch (state) {
        @case ('initial') {
          <div class="loading-spinner">
            <p-progressSpinner></p-progressSpinner>
            <div>Initializing ...</div>
          </div>
        }
        @case ('tokenInvalid') {
          <div class="error">
            The token in the URL is invalid.
            Did you copy the URL correctly?
          </div>
        }
        @case ('awaitingResponse') {
          <div class="loading-spinner">
            <p-progressSpinner></p-progressSpinner>
            <div>Waiting for server response ...</div>
          </div>
        }
        @case ('responseSuccess') {
          <div class="success">
            <div>Successfully changed your email address!</div>
            <button pButton label="Back To Login" routerLink="/login"></button>
          </div>
        }
        @case ('responseError') {
          <div class="error">
            {{ error | errorMsg | async }}
          </div>
        }
      }
    </div>
  </div>
</div>
